import { controlePatientStatusStyle } from "../controlePatientStyles";
import { CHARTER_COLORS as theme, PATIENT_STATUS_PALETTE, validationStatusColors } from "../shared/controleTheme";
import { buttonBase } from "../shared/styles/layoutStyles";
import { controlePatientCountStyle, lastDossierButtonStyle } from "../shared/styles/patientStyles";

export const preProductionHeroStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    padding: "22px 26px",
    background: theme.primary,
    border: `1px solid ${theme.primary}`,
    borderRadius: 0,
};

export const preProductionHeroTrackStyle = {
    display: "block",
    width: "220px",
    maxWidth: "100%",
    height: "8px",
    marginTop: "7px",
    borderRadius: "999px",
    background: "rgba(255, 255, 255, 0.22)",
    overflow: "hidden",
};

export const preProductionHeroFillStyle = {
    display: "block",
    height: "100%",
    background: theme.accent,
};

export const preProductionHeroBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    minHeight: "30px",
    padding: "0 12px",
    borderRadius: "999px",
    background: "rgba(200, 164, 77, 0.28)",
    color: "#fff6dc",
    fontSize: "12px",
    fontWeight: 900,
};

export const preProductionPatientCardStyle = {
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 14px rgba(12, 59, 60, 0.05)",
};

export const preProductionPatientCardHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    padding: "16px 20px",
    background: theme.surface,
    borderBottom: `1px solid ${theme.border}`,
};

export const preProductionPatientToggleStyle = {
    width: "100%",
    border: 0,
    borderLeft: `4px solid ${theme.primary}`,
    borderRadius: "8px 8px 0 0",
    padding: "16px 18px",
    background: theme.primarySoft,
    color: theme.ink,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    cursor: "pointer",
    flexWrap: "wrap",
};

export const preProductionPatientChevronStyle = open => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    borderRadius: "999px",
    background: open ? theme.surface : "rgba(12, 59, 60, 0.08)",
    color: theme.primary,
    fontSize: "21px",
    fontWeight: 900,
    lineHeight: 1,
    transform: open ? "rotate(90deg)" : "rotate(0deg)",
    transition: "transform 0.16s ease, background 0.16s ease",
    flexShrink: 0,
});

export const preProductionLockedBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    minHeight: "28px",
    padding: "0 10px",
    borderRadius: "999px",
    background: theme.successSoft,
    border: "1px solid #a9e8cf",
    color: "#0d704a",
    fontSize: "12px",
    fontWeight: 900,
};

export const preProductionFooterStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    padding: "18px 22px",
    background: "white",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
};

export const controlePatientWorkspaceStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(230px, 300px) minmax(0, 1fr)",
    gap: "0",
    alignItems: "start",
};

export const controlePatientModalOverlayStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 1150,
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    padding: "18px",
    background: "rgba(15, 23, 42, 0.46)",
};

export const controlePatientModalStyle = {
    width: "min(1180px, 100%)",
    maxHeight: "calc(100vh - 36px)",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    background: "#f8fafc",
    boxShadow: "0 28px 70px rgba(15, 23, 42, 0.30)",
    overflow: "hidden",
};

export const controlePatientModalHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    padding: "16px 18px",
    background: "white",
    borderBottom: "1px solid #e2e8f0",
    flexShrink: 0,
};

export const controlePatientModalBodyStyle = {
    minHeight: 0,
    overflowY: "auto",
    padding: "14px",
};

export const controlePatientSidebarStyle = {
    display: "grid",
    position: "sticky",
    top: "12px",
    alignSelf: "start",
    background: "white",
    border: 0,
    borderRight: `1px solid ${theme.border}`,
    borderRadius: 0,
    overflow: "hidden",
    maxHeight: "calc(100vh - 280px)",
};

export const controlePatientHeaderStyle = {
    display: "grid",
    gap: "9px",
    padding: "14px",
    borderBottom: `1px solid ${theme.border}`,
};

export const controlePatientItemWrapperStyle = (active, inactive, validated, blocking) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    border: 0,
    borderRadius: "0",
    ...controlePatientStatusStyle({ active, inactive, validated, blocking }, PATIENT_STATUS_PALETTE),
    marginBottom: "3px",
});

export const controlePatientAvatarStyle = (active, inactive, validated, blocking) => ({
    width: "34px",
    height: "34px",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: inactive ? "#C1422E" : blocking ? "#C8A44D" : validated ? theme.accent : active ? theme.primary : "#e8f1ef",
    color: inactive || active || validated || blocking ? "white" : theme.primary,
    fontWeight: 800,
    fontSize: "11px",
    flexShrink: 0,
});

export const controlePatientWarningCountStyle = {
    ...controlePatientCountStyle,
    background: theme.warningSoft,
    color: "#80620e",
    border: "1px solid #ead99b",
};

export const patientControlPointNumberStyle = (validated, blocking) => ({
    background: validated ? theme.accent : blocking ? theme.warningSoft : theme.primarySoft,
    border: `1px solid ${validated ? theme.accent : blocking ? "#ead99b" : "#b9d4cc"}`,
    color: validated ? "white" : blocking ? "#80620e" : theme.primary,
});

export const patientValidateButtonStyle = {
    ...buttonBase,
    height: "40px",
    padding: "0 16px",
    background: theme.primary,
    borderColor: theme.primary,
    color: "white",
    fontWeight: 900,
};

export const patientValidatedButtonStyle = {
    ...patientValidateButtonStyle,
    background: theme.successSoft,
    borderColor: "#a9e8cf",
    color: "#0d704a",
};

export const patientValidateAllPointsButtonStyle = {
    ...buttonBase,
    height: "40px",
    padding: "0 16px",
    background: "white",
    borderColor: theme.border,
    color: theme.ink,
    fontWeight: 900,
};

export const lastDossierActiveButtonStyle = {
    ...lastDossierButtonStyle,
    background: "#0f172a",
    borderColor: "#0f172a",
    color: "white",
};

export const controlePatientDetailStyle = {
    display: "grid",
    gap: "14px",
    background: "white",
    border: 0,
    borderRadius: 0,
    padding: "0 16px 16px",
};

export const controlePatientEmptyDetailStyle = {
    ...controlePatientDetailStyle,
    minHeight: "180px",
    alignContent: "center",
    justifyItems: "center",
    textAlign: "center",
};

export const controlePatientDetailHeaderStyle = {
    display: "flex",
    position: "sticky",
    top: "-14px",
    zIndex: 80,
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    margin: "-14px -16px 0",
    padding: "30px 16px 16px",
    borderBottom: `1px solid ${theme.border}`,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    background: "white",
    boxShadow: "0 8px 18px rgba(12, 59, 60, 0.05)",
};

export const validationStatusPillStyle = value => ({
    display: "inline-flex",
    alignItems: "center",
    minHeight: "22px",
    padding: "0 8px",
    borderRadius: "999px",
    border: `1px solid ${validationStatusColors(value).borderColor}`,
    background: validationStatusColors(value).background,
    color: validationStatusColors(value).color,
    fontSize: "11px",
    fontWeight: 950,
});

export const controlePointListStyle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "8px",
};

export const controlePatientPointCardStyle = (validated, blocking) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    minHeight: "58px",
    padding: "10px 12px",
    borderRadius: "8px",
    border: blocking ? "1px solid #fecaca" : validated ? "1px solid #86efac" : "1px solid #e2e8f0",
    background: blocking ? "#fff7f7" : validated ? "#f0fdf4" : "#f8fafc",
});

export const controlePatientPointShellStyle = {
    display: "grid",
    gap: "6px",
};

export const lastDossierPointInlineStyle = {
    display: "grid",
    gap: "6px",
    marginLeft: "40px",
    padding: "9px 10px",
    borderRadius: "8px",
    border: "1px solid #bfdbfe",
    background: "#eff6ff",
    boxShadow: "inset 3px 0 0 #2563eb",
};

export const sharedPatientCommentCardStyle = {
    display: "grid",
    gap: "8px",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #bfdbfe",
    background: "#eff6ff",
};

export const patientLaunchStatusCardStyle = launched => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    minHeight: "58px",
    padding: "10px 12px",
    borderRadius: "8px",
    border: launched ? "1px solid #86efac" : "1px solid #fed7aa",
    background: launched ? "#f0fdf4" : "#fff7ed",
});

export const patientLaunchMetaStyle = {
    marginTop: "4px",
    color: "#166534",
    fontSize: "12px",
    fontWeight: 850,
};
